import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';

import BufferTabView from 'buffers/BufferTabView';
import * as ReduxDOMRender from 'redux-stores/ReduxDOMRender';

import EntityTestOrdersTabState from './EntityTestOrdersTabState';
import EntityTestOrdersView from './EntityTestOrdersView';

export default class EntityTestOrdersTabView extends BufferTabView<EntityTestOrdersTabState> {
  render(): this {
    const modelId = this.model.get('modelId');
    ReduxDOMRender.renderToDOM(<EntityTestOrdersView entityId={modelId} />, this.el);
    return this;
  }

  remove(): Backbone.View<EntityTestOrdersTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

EntityTestOrdersTabView.prototype.className = 'buffer-tab buffer-tab--no-padding';
